import app from './config/configApp';
import router from './routes/protectedRoute';
import store from '@/vuex/store';
import './static/css/style.css';
import './validators';
//import Modal from './components/Modal.vue'
// Vue 3rd party plugins

import '@/core/plugins/ant-design';
import '@/core/plugins/fonts';
import '@/core/components/custom';
import '@/core/components/style';

app.config.productionTip = false;
app.use(store);
app.use(router);
app.mount('#app'); 
//app.component('Modal',Modal);

